module.exports = __webpack_public_path__ + "static/media/step1.881170b0.svg";